// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
//require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("src/webflow")
require("src/tour")
require("src/bootstrap-tooltips")
require("jquery")
require("src/competition")
require("src/golf_pool")
require("src/golf_knockout")
require("src/horizantal_scroll_bar")
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net';
import '../datatables/init';

//require("tinymce-jquery")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


$( document ).ready(function() {
	//$("#competition_start_date").datepicker({dateFormat: 'mm/dd/yy'});
	//$("#competition_end_date").datepicker({dateFormat: 'mm/dd/yy'});

	$("#competition_player_id").change ( function () {
		window.location.replace('/competition/player_detail/'+$(this).val());
	});

	//these 2 lines are for admin page
	$("#parlay-max").toggle($("#competition_parlays").prop("checked"));
	$("#bet-max").toggle($("#competition_max_bet").prop("checked"));

	$("#competition_parlays").on("click", function() {
		$("#parlay-max").toggle(this.checked);
	});

	$("#competition_max_bet").on("click", function() {
		$("#bet-max").toggle(this.checked);
	});

	$("#segment-pct").toggle($("#competition_segments").prop("checked"));

	$("#competition_segments").on("click", function() {
		$("#segment-pct").toggle(this.checked);
	});

	$("#addPlayerButton").on("click", function(){
		$('#addPlayer').slideToggle();
	})

	$(window).scroll(function(){
    if ($(window).scrollTop() >= 230) {
       $('.compHeader').addClass('fixed-header');
       $('.groupHeader').addClass('fixed-group-header');
    }
    else {
       $('.compHeader').removeClass('fixed-header');
       $('.groupHeader').removeClass('fixed-group-header');
    }
    });

    $('.bet_adj').click(function(event){


    	var field = $(this).attr('data-field');
		var input = $('#' + field + '_amount');
		var pct = $(this).attr('data-pct');

		updateUI(input, pct, parseInt(input.val()));

	});


	$('.bet_pct').click(function(event){

		var key = $(this).attr('data-key');
		var inputs = $('input.' + key + '_amount');
		var pct = $(this).attr('data-pct');

		inputs.each(function(i, el) {

			updateUI($(el), pct, 0);

		});

	});

	$('.amount').on('input', function() {

		var val = parseInt($(this).val());
		var points = $(this).attr('data-points');

		if (Number.isInteger(val)) {
    		updateUI($(this), val/points, 0);
    	}
    	else {
    		$(this).val("");
    	}
	});

	function updateUI(input, pct, starting) {

		var points = input.attr('data-points')
		var max = input.attr('data-max')

		var calc = Math.round(points * pct) + starting
		var new_amount = Math.min(Math.max(0, calc), parseInt(max))

		var field = input.attr('data-bet-uniq-id');

		input.val(new_amount)
		var new_pct = Math.round(new_amount/parseInt(points) * 100)
		var divWidth = $('#competitions').width();

		//$('.' + field + '_pct').animate({'width': (divWidth * (new_pct / 100)) + 'px'})
		$('.' + field + '_pct').width(new_pct + '%')
		$('.' + field + '_pctval').text(new_pct + '%').css("margin-left", Math.min(Math.max(0,new_pct - 3),92) + '%')

	}

	$('#competitions-cb').click(function(event){

		$('input:checkbox').not(this).prop('checked', this.checked);

	});

	//add the tab anchor to the url
	Webflow.push(function() {
		$('.do-anchor').each(function() {
		  $(this).attr('href', '#' + $(this).attr('data-w-tab').toLowerCase().replace(/[^a-z0-9]+/, '-'));
		});
		if(location.hash != '') $('.w-tab-link[href="'+location.hash+'"]').trigger('click');
	});


	$(".trigger").click(function(){
    	$(this).next(".toggle").slideToggle("fast");
    	$(this).find(".caret-toggle").toggleClass("down")  ; 
  });

	$('.modal-button').click(function() {
		var modalOverlay = document.querySelector('.modal-overlay');
		modalOverlay.style.display = 'none';
	})
	
});